import { render, staticRenderFns } from "./UploadSourceSelector.vue?vue&type=template&id=050b4a8a&scoped=true"
import script from "./UploadSourceSelector.vue?vue&type=script&lang=js"
export * from "./UploadSourceSelector.vue?vue&type=script&lang=js"
import style0 from "./UploadSourceSelector.vue?vue&type=style&index=0&id=050b4a8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050b4a8a",
  null
  
)

export default component.exports